import { Link } from "react-router-dom";
import {
  Youtube,
  Twitter,
  Linkedin,
  Instagram,
  Mail,
  MessageSquare,
  Phone,
  MapPin
} from "lucide-react";
import { ROUTES } from "src/routes/RouteConfig";

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-5 xl:grid-cols-[minmax(0,1.8fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1.2fr)]">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="text-2xl font-bold text-rfpurple-600">
              rfLearn
            </Link>
            <p className="mt-2 max-w-[17rem] text-sm text-gray-500">
              Reinforcement-based learning platform combining AI and human expertise.
            </p>
            <div className="flex space-x-4 mt-4">
              <a
                href="https://x.com/rfLearn_ed"
                className="text-gray-400 hover:text-black transition-colors duration-200"
                aria-label="Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter size={20} />
              </a>
              <a
                href="https://www.instagram.com/rflearn.ed"
                className="text-gray-400 hover:text-pink-500 transition-colors duration-200"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://youtube.com/@rflearn_ed"
                className="text-gray-400 hover:text-red-500 transition-colors duration-200"
                aria-label="Youtube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Youtube size={20} />
              </a>
              <a
                href="https://www.linkedin.com/company/reinforcement-learning-solutions"
                className="text-gray-400 hover:text-blue-600 transition-colors duration-200"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
              Platform
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to={ROUTES.COURSE_MATHEMATICS.path} className="text-base text-gray-500 hover:text-rfpurple-500">
                  Mathematics
                </Link>
              </li>
              <li>
                <Link to={ROUTES.COURSE_PYTHON.path} className="text-base text-gray-500 hover:text-rfpurple-500">
                  Python
                </Link>
              </li>
              <li>
                <Link to={ROUTES.COURSE_JAVASCRIPT.path} className="text-base text-gray-500 hover:text-rfpurple-500">
                  JavaScript
                </Link>
              </li>
              <li>
                <Link to={ROUTES.TUTORS.path} className="text-base text-gray-500 hover:text-rfpurple-500">
                  Tutors
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-base text-gray-500 hover:text-rfpurple-500">
                  Resources
                </Link>
              </li>
              <li>
                <Link to={ROUTES.PRICING.path} className="text-base text-gray-500 hover:text-rfpurple-500">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
              Company
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/about" className="text-base text-gray-500 hover:text-rfpurple-500">
                  About
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-base text-gray-500 hover:text-rfpurple-500">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-base text-gray-500 hover:text-rfpurple-500">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to={ROUTES.TERMS.path} className="text-base text-gray-500 hover:text-rfpurple-500">
                  Terms
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-1 md:col-span-2 xl:col-span-1">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
              Contact
            </h3>
            <ul className="mt-4 space-y-2">
              <li className="flex items-center">
                <Mail size={16} className="text-gray-400 mr-2" />
                <a href="mailto:info@rflearn.com" className="text-base text-gray-500 hover:text-rfpurple-500">
                  info@rflearn.com
                </a>
              </li>
              <li className="flex items-center">
                <MessageSquare size={16} className="text-gray-400 mr-2" />
                <Link to="/inquiry" className="text-base text-gray-500 hover:text-rfpurple-500">
                  Send an inquiry
                </Link>
              </li>
              <li className="flex items-center">
                <MessageSquare size={16} className="text-gray-400 mr-2" />
                <Link to="/feedback" className="text-base text-gray-500 hover:text-rfpurple-500">
                  Leave feedback
                </Link>
              </li>
              <li className="flex items-center">
                <Phone size={16} className="text-gray-400 mr-2" />
                <a href="tel:+18884388036" className="text-base text-gray-500 hover:text-rfpurple-500">
                  US: (+1) 888 438 8036
                </a>
              </li>
              <li className="flex items-center">
                <Phone size={16} className="text-gray-400 mr-2" />
                <a href="tel:+918690845205" className="text-base text-gray-500 hover:text-rfpurple-500">
                  India: (+91) 8690845205
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-400 text-center">
            &copy; Reinforcement Learning Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
